import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigation } from '../../../shared/contexts/NavigationContext';
import { WallPost } from '../../../api/wallPostsApi';
import PhotoGrid from '../../profile/ui/PhotoGrid';
import styles from '../../profile/ui/PostsFeed.module.css';

interface FavoritesGridOverlayProps {
  isOpen: boolean;
  posts: WallPost[];
  onClose: () => void;
  onPostClick: (post: WallPost, imageIndex: number) => void;
  title?: string;
}

const FavoritesGridOverlay: React.FC<FavoritesGridOverlayProps> = ({
  isOpen,
  posts,
  onClose,
  onPostClick,
  title = 'Избранное'
}) => {
  const { showBack, hideBack } = useNavigation();

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    showBack(onClose, true);
    return () => hideBack();
  }, [isOpen, showBack, hideBack, onClose]);

  useEffect(() => {
    if (!isOpen) return;

    const scrollY = window.scrollY;
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalTop = document.body.style.top;
    const originalWidth = document.body.style.width;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.top = originalTop;
      document.body.style.width = originalWidth;
      window.scrollTo(0, scrollY);
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  const modalContent = (
    <div className={styles.feedOverlay}>
      <div className={styles.feedHeader}>
        <button
          type="button"
          className={styles.feedBackButton}
          onClick={onClose}
          aria-label="Назад"
          title="Назад"
        >
          <i className="ri-arrow-left-s-line" aria-hidden />
        </button>
        <h2 className={styles.feedTitle}>{title}</h2>
        <div className={styles.headerSpacer}></div>
      </div>
      <div className={styles.feedContainer}>
        <PhotoGrid posts={posts} onPostClick={onPostClick} />
      </div>
    </div>
  );

  return typeof document !== 'undefined' ? createPortal(modalContent, document.body) : null;
};

export default FavoritesGridOverlay;
